import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = ["error"];

  connect() {
    this.stopped = false;
    this.timer = setTimeout(() => this.poll(), 1500);
  }

  disconnect() {
    this.stopped = true;
    clearTimeout(this.timer);
    this.abort?.abort();
  }

  async poll() {
    this.abort = new AbortController();
    try {
      const response = await fetch(this.urlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
        signal: this.abort.signal,
      });
      if (!response.ok) throw new Error("Poll failed");
      const result = await response.json();
      if (this.stopped) return;
      if (!result.pending) {
        window.location.replace(result.url);
        return;
      }
    } catch {
      if (this.stopped) return;
      this.errorTarget.hidden = false;
    }
    this.timer = setTimeout(() => this.poll(), 1500);
  }
}
